// 確認ダイアログ（W-E 内の共通部品。GfModal のラッパ）
import type { ReactNode } from "react";
import { GfButton, GfModal } from "../../ui/GfUi";

export function ConfirmModal({
  open,
  title,
  children,
  confirmLabel,
  busy,
  danger,
  onConfirm,
  onClose,
}: {
  open: boolean;
  title: ReactNode;
  children: ReactNode;
  confirmLabel: string;
  busy?: boolean;
  danger?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <GfModal
      open={open}
      title={title}
      width={440}
      onClose={busy ? () => undefined : onClose}
      footer={
        <>
          <GfButton onClick={onClose} disabled={busy}>
            キャンセル
          </GfButton>
          <GfButton variant={danger ? "danger" : "primary"} onClick={onConfirm} disabled={busy}>
            {busy ? "処理中…" : confirmLabel}
          </GfButton>
        </>
      }
    >
      <div className="gf-confirm-body">{children}</div>
    </GfModal>
  );
}
